import { useElementSize } from '@mantine/hooks';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';

const TopSKUs = ({ data = [], statuses = [] }) => {
	const { ref, width } = useElementSize();
	const filteredData =
		statuses.length > 0
			? data.filter((row) => statuses.includes(row.request_status))
			: data;
	const chartData = filteredData.reduce((prev, row) => {
		if (!row.sku_label) {
			return prev;
		}
		if (!prev[row.sku_label]) {
			prev[row.sku_label] = 1;
		} else {
			prev[row.sku_label]++;
		}
		return prev;
	}, {});
	const mappedData = sortBy(
		Object.entries(chartData).map(([category, count]) => ({
			category,
			count,
		})),
		['count'],
	).reverse();
	const categories = mappedData.map(({ category }) => category);
	const seriesData = mappedData.map(({ count }) => count);
	const height = Math.max(mappedData.length * 50, 120);
	let tickAmount = 5;
	if (Math.max(...seriesData) < 5) {
		tickAmount = Math.max(...seriesData);
	}
	return (
		<div ref={ref}>
			<div className="text-xl">Top SKUs</div>
			{mappedData.length === 0 ? (
				<div className="mt-4 text-center text-gray-500">
					No SKU data available
				</div>
			) : (
				<Chart
					type="bar"
					width={width}
					height={height}
					options={{
						chart: { stacked: true },
						colors: ['#3abddb'],
						xaxis: {
							categories,
							tickAmount,
							labels: {
								formatter: function (value) {
									return value.toFixed(0);
								},
							},
						},
						plotOptions: {
							bar: {
								horizontal: true,
							},
						},
					}}
					series={[{ name: 'Count', data: seriesData }]}
				/>
			)}
		</div>
	);
};

TopSKUs.propTypes = {
	data: PropTypes.array,
	statuses: PropTypes.array,
};

export default TopSKUs;
